import { TWO_WEEKS } from "../../Constants/AppData";

export const requiredField = value => (value ? undefined : "This field is required");
export const pickOne = value => (value ? undefined : "Please pick one option.");
export const pickAtLeastOne = value => (value && value.length > 0 ? undefined : "Please pick at least one option");
export const requiredUpload = value => ((value && Object.keys( value ).length !== 0) ? undefined : "This upload is required.");
export const minValue = min => value =>
    isNaN( value ) || value >= min ? undefined : `The value should be greater than ${ min }.`;
export const atLeastTwoWeeks = value => {
    const dateNow = new Date();
    const dateNowISO = Date.parse( dateNow.toISOString().substr( 0, 10 ) );
    let output;
    if ( (Date.parse( value ) - dateNowISO) < TWO_WEEKS ) {
        output = 'Please select a valid date.'
    }
    return output;
}

export const composeValidators = ( ...validators ) => value =>
    validators.reduce( ( error, validator ) => error || validator( value ), undefined );
